/**
 * Detects restrictive in-app browsers (TikTok, Snapchat, Facebook Messenger, Line, etc.)
 * that block programmatic redirects to app stores.
 * Instagram's WebView is more permissive so it's excluded.
 */
export function isInAppBrowser(): boolean {
  if (typeof navigator === 'undefined') return false;
  const ua = navigator.userAgent || '';
  return /musical_ly|TikTok|Snapchat|FBAN\/MessengerForiOS|Line\//i.test(ua);
}
